module.exports = __webpack_public_path__ + "static/media/RoundedRect_Quinary.09709908.png";